import React from "react";

export default function PhoneLink() {
    return <a href="tel:+39-041-448721">
        +39 041 448721
    </a>
}